var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "podpis-event-banner"
  }, [_vm._m(0), _c('div', {
    staticClass: "div-block-146"
  }, [_vm.zipLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner small",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('button', {
    staticClass: "w-button",
    on: {
      "click": _vm.download
    }
  }, [_vm._v(" Stiahnuť podklady ")])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-142"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f3b_document%20icon.png",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "div-block-143"
  }, [_c('div', {
    staticClass: "bold blc-color"
  }, [_vm._v("Vygenerovať .zip podkladov na schválenie")])])]);

}]

export { render, staticRenderFns }